import {
  internalNameSettingKey,
  previewViewModes,
} from '@/configuration/pages/ConfigurationPage/OrderTrackingPageConfiguration/constants'
import {
  getBlockDefinition,
  getBlockSettingFields,
  getBlockSettings,
} from '@/configuration/pages/ConfigurationPage/OrderTrackingPageConfiguration/helpers'

export const buildBlockSettingsFromSavedLayout = savedLayout => {
  const entries = savedLayout[previewViewModes.desktop].map(item => [
    item.id,
    getBlockSettings(getBlockDefinition(item.id), item.settings),
  ])

  return Object.fromEntries(entries)
}

export const haveBlockSettingsChanged = (layout, blockSettings, referenceBlockSettings) => {
  return layout.some(item => {
    return JSON.stringify(blockSettings[item.i]) !== JSON.stringify(referenceBlockSettings[item.i])
  })
}

export const hasInternalNameSetting = definition => {
  return getBlockSettingFields(definition).some(field => field.key === internalNameSettingKey)
}

const countBlocksOfType = (layout, definition) => {
  return layout.filter(item => getBlockDefinition(item.i).id === definition.id).length
}

export const buildDefaultInternalName = (definition, layout, t) => {
  return `${t(definition.label)} #${countBlocksOfType(layout, definition) + 1}`
}

export const getBlockAspectRatio = ({ width, height }) => Math.round((width / height) * 100) / 100
